
const region = "ap-south-1";
const bucket = "coobo";

module.exports = "https://coobo-prod.azureedge.net/assets";